import * as actionTypes from "../../Actions";

const initialState = {
    success: false
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.CREATE_PAY_TASK_HISTORY:
            return {
                ...state,
                success: action.payload
            }
        default:
            return state;
    }
}

export default reducer;
